import { makeStyles } from "@material-ui/core/styles";

export const useTerminalsStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  terminalListTitle: {
    fontWeight: "bold",
    fontSize: "1.7em",
  },
  SearchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  searchPaper: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400,
  },
  addNewIconRight: {
    marginRight: theme.spacing(1),
  },
  deleteIconMargin: {
    marginRight: theme.spacing(1),
    backgroundColor: "white",
    boxShadow: "none",
    borderRadius: "0.3em",
  },
  editIconMargin: {
    marginRight: theme.spacing(1),
     backgroundColor: "white",//"#8bc34a",
    boxShadow: "none",
    borderRadius: "0.3em",
    "&:hover": {
      backgroundColor:"#717d8a",
    }
  },
  editIcon: {
    width: ".90em",
    height: ".90em",
    color:"#3d5a79 !important",
  },
  deleteIcon: {
    width: "1em",
    height: "1em",
    color:"royalblue",
  },
  table: {
    minWidth: 960,
  },
  fieldSpace: {
    paddingTop: "3em",
    paddingLeft: "3em",
    paddingRight: "3em",
    paddingBottom: "3em",
  },
  userTitle: {
    paddingLeft: "1em",
    paddingBottom: "1em",
    fontWeight: "bold",
    fontSize: "2em",
  },
  commonButtonStyle: {
    paddingTop: "3em",
    textAlign: "right",
  },
  commonButtonPosition: {
    paddingTop: "2.50em",
  },
  tableMessage:{
    color:"black",
    fontWeight:"bold",
    fontSize:"1.3em",
    textAlign:"right",
    paddingLeft:"5em"
  },
  fieldLabelStyles:{
    paddingBottom:"1em",
    fontWeight:"bold"
  }
}));
